export default __webpack_public_path__ + "static/media/Helm of the Black Dragon.a5147e1a.jpg";